import Vue from 'vue'
import Vuex from 'vuex'
import { firebaseAuth, firebaseDatabase } from '@/services/firebase'
import { v4 as uuidv4 } from 'uuid'

Vue.use(Vuex)

export default {
  namespaced: true,
  state: {
    collabs: [],
    deletedCollabs: [],
  },
  mutations: {
    setCollabs(state, payload) {
      state.collabs = payload
    },
    insertCollab(state, payload) {
      const collab = {
        collabID: uuidv4(),
        data: {
          collabURL: payload.collabURL,
          channelName: payload.snippet1.snippet.title,
          thumbnailUrl: payload.snippet1.snippet.thumbnails.default,
          subscriberCount: payload.statistics1.statistics.subscriberCount,
          videoCount: payload.statistics1.statistics.videoCount,
        },
        change: 'create',
      }
      state.collabs.push(collab)
    },
    removeCollab(state, payload) {
      console.log(payload)
      const index = state.collabs.indexOf(payload)
      console.log(index)
      if (index > -1) {
        state.collabs.splice(index, 1)
      }
      state.deletedCollabs.push(payload)
      console.log(state.deletedCollabs)
    },
  },
  actions: {
    // read videos when app loads
    getCollabs(context) {
      const payload = []
      firebaseDatabase.collection('creators')
        .doc(firebaseAuth.currentUser.uid)
        .collection('collabs')
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            const data = {
              collabID: doc.id,
              data: doc.data(),
            }
            payload.push(data)
          })
        })
      context.commit('setCollabs', payload)
    },
    // update an existing video
    async updateVideo(context, video) {
      console.log(context)
      const videoData = video.video.data
      const videoID = video.video.videoID
      firebaseDatabase.collection('creators')
        .doc(firebaseAuth.currentUser.uid)
        .collection('videos')
        .doc(videoID)
        .set(videoData)
    },
    // delete a video
    async deleteVideo(context, video) {
      console.log(context)
      const videoID = video.video.videoID
      firebaseDatabase.collection('creators')
        .doc(firebaseAuth.currentUser.uid)
        .collection('videos')
        .doc(videoID)
        .delete()
        // .then(res => {
        //   console.log(res)
        //   context.commit('removeVideo', video)
        // })
    },
  },
  getters: {
    state: state => state,
  },
}
